<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <h5 class="txt-dark">
            Class Societies
            <add-button link="/settings/class-societies/create"></add-button>
            <refresh-button @click="getData"></refresh-button>
          </h5>
          <my-search :search="search" placeholder="Search value..." @searchData="searchData"></my-search>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-6 col-sm-6 col-md-6 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Class Societies</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->
      
      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table :isLoading="isLoading" cols="5"></loading-table>
                      <router-link 
                        v-for="(classSociety, at) in classSocieties"
                        :key="`classSociety${at}`"
                        :to="`/settings/class-societies/${classSociety.id}`"
                        tag="tr"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ classSociety.name }}</td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <pagination :count="count" @submit="getData"></pagination>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'ClassSocieties',
  data () {
    return {
      classSocieties: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      search: '',
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(page = 1, search = '') {
      this.isLoading = true
      let classSocieties = await axios.get(`/class_societies?page=${page}&rowsPerPage=${this.rowsPerPage}&search=${search}`)
      this.classSocieties = classSocieties.data.data
      this.count = classSocieties.data.count
      this.serialNoStarting = (page - 1) * this.rowsPerPage
      this.isLoading = false
    },
    searchData(value) {
      this.getData(1, value)
    }
  }
}
</script>

<style>


th {
  
}
</style>